module.exports = __webpack_public_path__ + "img/1-5.5ad95f1e.svg";